module.exports = __webpack_public_path__ + "static/media/fidweb-article-fight-scout-new-website.be6179d4.png";